module.exports = __webpack_public_path__ + "static/media/fiat.70c45e9c.png";